import { API_URL } from "../config";
import { CBEWSL_SITE } from "../host";
import axios from "axios";
const SITE_ID = CBEWSL_SITE;

export const getAllHouseholds = (callback) => {
  axios
    .get(`${API_URL}/api/household_data/get_all/${SITE_ID}`)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {});
};

export const getSummary = (callback) => {
  axios
    .get(`${API_URL}/api/household_data/get_summary/${SITE_ID}`)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {});
};

export const getPregnant = (callback) => {
  axios
    .get(`${API_URL}/api/household_data/get_pregnant/${SITE_ID}`)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {});
};

export const getComorbid = (callback) => {
  axios
    .get(`${API_URL}/api/household_data/get_comorbidity/${SITE_ID}`)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {});
};

export const getDisabled = (callback) => {
  axios
    .get(`${API_URL}/api/household_data/get_disability/${SITE_ID}`)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {});
};

export const getSenior = (callback) => {
  axios
    .get(`${API_URL}/api/household_data/get_seniors/${SITE_ID}`)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {});
};

export const getChildren = (callback) => {
  axios
    .get(`${API_URL}/api/household_data/get_children/${SITE_ID}`)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {});
};

export const getToddler = (callback) => {
  axios
    .get(`${API_URL}/api/household_data/get_toddlers/${SITE_ID}`)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {});
};

export const addHousehold = (data, callback) => {
  axios
    .post(`${API_URL}/api/household_data/add`, data)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {});
};

export const editHousehold = (data, callback) => {
  axios
    .patch(`${API_URL}/api/household_data/update`, data)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {});
};

export const deleteHousehold = (submitData, callback) => {
  axios
    .delete(`${API_URL}/api/household_data/delete`, { data: submitData })
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {});
};
